// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#default .container{background-color:#fafafa;margin:0;padding:0}#default #list .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled){color:#9e9e9e!important}#default .v-app-bar.white{border-bottom:1px solid #eee!important}#default .nav-header{border-bottom:1px solid rgba(0,0,0,.12)}#default .v-toolbar__content{padding:4px 8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
